import type { AxiosInstance } from 'axios'

import type {
  MediaGroup,
  MediaGroupMedia,
  MediaId,
  MediaGroupId,
  MediaGroupMediaId,
} from '@/types'

import BaseService from './BaseService'

export default class MediaGroupService extends BaseService<
  MediaGroup,
  Partial<MediaGroup>
> {
  constructor(client: AxiosInstance) {
    super(client, 'media-group')
  }

  async add(id: MediaGroupId, ids: MediaId[]): Promise<MediaGroupMedia> {
    const { data } = await this.client.post('/media-group-media/bulk', {
      bulk: ids.map((i) => ({ mediaGroupId: id, mediaId: i })),
    })
    return data
  }

  async remove(id: MediaGroupMediaId): Promise<MediaGroupMediaId> {
    await this.client.delete<MediaGroupMediaId>(`/media-group-media/${id}`)
    return id
  }

  async updateMedia(payload: Partial<MediaGroupMedia>) {
    return await this.client.patch(`/media-group-media/${payload.id}`, payload)
  }

  static MEDIA_RELATION = 'media'
  static MEDIA_MEDIA_RELATION = 'media.media'
}
